/* eslint-disable react/prop-types */
import React from 'react';
import { Row, Col, Placeholder } from '@thd-olt-component-react/core-ui';

const PlaceholderSkeleton = () => (
  <div className="grid">
    <Row>
      <Col fallback="8">
        <Placeholder type="rect" height="25px" width="auto" />
      </Col>
    </Row>
    <Row>
      <Col fallback="6">
        <Placeholder type="rect" height="25px" width="auto" />
      </Col>
    </Row>
    <Row>
      <Col fallback="3">
        <Placeholder type="rect" height="200px" width="auto" />
      </Col>
      <Col fallback="3">
        <Placeholder type="rect" height="200px" width="auto" />
      </Col>
      <Col fallback="3">
        <Placeholder type="rect" height="200px" width="auto" />
      </Col>
      <Col fallback="3">
        <Placeholder type="rect" height="200px" width="auto" />
      </Col>
    </Row>
  </div>
);

const Placeholders = ({ rows }) => (
  <div style={{ minHeight: '100vh' }}>
    {rows.map((index) => (
      <PlaceholderSkeleton key={index} />
    ))}
  </div>
);

export default Placeholders;
